/*
 * YearsTabs Messages
 *
 * This contains all the text for the YearsTabs component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  orderBy: {
    id: 'NavTabs.orderBy',
    defaultMessage: 'Order by',
  },
  all: {
    id: 'NavTabs.all',
    defaultMessage: 'All',
  },
  page: {
    id: 'NavTabs.page',
    defaultMessage: 'Page',
  },
  of: {
    id: 'NavTabs.of',
    defaultMessage: 'of',
  },
  next: {
    id: 'NavTabs.next',
    defaultMessage: 'Next',
  },
  previous: {
    id: 'NavTabs.previous',
    defaultMessage: 'Previous',
  },
});
